export const CompetitionAddress = "0xc2A9AFab3B743bd596e11Cb972BD1A879B41cAC0";
